export default __webpack_public_path__ + "static/media/145859.fa328fc9.svg";